import { render, staticRenderFns } from "./DeliveryAddressDetails.vue?vue&type=template&id=4ec29d66&scoped=true"
import script from "./DeliveryAddressDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec29d66",
  null
  
)

export default component.exports